import { Button } from '@repo/shadcn';

import { PlusIcon } from '@assets/svg.icons/icons.tsx';

import { DEFAULT_PAGE_LIMIT } from '@/constants';

import { useUrlPagination } from '../../../hooks';
import { formatCurrencyInBDT } from '../../../utils';
import { DataTable } from '../../ui/data.table/data-table';
import HeadingWrapper from '../../ui/heading/heading-wrapper';
import PageHeading from '../../ui/heading/page-headeing';
import PaginationComponent from '../../ui/pagination';
import { expenseColumns } from './expense.column';
import { useExpense } from './expense.hook';

export const Expense = () => {
    const { page, setCurrentPage } = useUrlPagination();
    const { data, isLoading, isError, openCreateExpenseModal } = useExpense();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return (
            <div>
                <p>Something went wrong!</p>
            </div>
        );
    }

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between py-4">
                    <PageHeading
                        title="Expense"
                        subTitle="Track Your Expenses"
                    />

                    <div className="flex gap-4">
                        <Button type="button" onClick={openCreateExpenseModal}>
                            <PlusIcon />
                            Add Expense
                        </Button>
                    </div>
                </div>
            </HeadingWrapper>

            <DataTable columns={expenseColumns} data={data?.data || []} />

            <div className="flex items-center justify-between">
                <p className="mt-3 flex items-center px-4 text-right text-base font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <p className="mt-3 flex items-center px-4 text-right text-base font-semibold">
                    Total Amount :{' '}
                    {formatCurrencyInBDT(data?.pagination?.total_amount || 0)}
                </p>
            </div>

            <PaginationComponent
                totalItems={data?.pagination?.total_items || 0}
                itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                initialPage={page}
                onPageChange={(p) => {
                    setCurrentPage(p);
                }}
            />
        </>
    );
};
